// Ubicación actual del caminante, como promesa. Opcional en los avisos: si no hay permiso,
// no hay señal GPS o tarda demasiado, devuelve null y el aviso se envía sin ubicación.
export type Position = { latitude: number; longitude: number }

const OPTIONS: PositionOptions = { enableHighAccuracy: true, timeout: 15_000, maximumAge: 60_000 }

export const getCurrentPosition = (
	geolocation: Geolocation | undefined = globalThis.navigator?.geolocation
): Promise<Position | null> =>
	new Promise((resolve) => {
		if (!geolocation) {
			resolve(null)
			return
		}
		geolocation.getCurrentPosition(
			({ coords }) =>
				resolve({
					latitude: Number(coords.latitude.toFixed(6)),
					longitude: Number(coords.longitude.toFixed(6)),
				}),
			() => resolve(null),
			OPTIONS
		)
	})
